import { request } from "./client";

export function fetchDreamcastPlaylists() {
  return request("/playlists");
}

export function fetchDreamcastPlaylistById(id) {
  return request(`/playlists/${id}`);
}

export function createDreamcastPlaylist(body) {
  return request("/playlists", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateDreamcastPlaylist(id, body) {
  return request(`/playlists/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function duplicateDreamcastPlaylist(id) {
  return request(`/playlists/${id}/duplicate`, {
    method: "POST",
  });
}

export function setDreamcastPlaylistStatus(id, workflowStatus, displayStatus) {
  return request(`/playlists/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ workflowStatus, displayStatus }),
  });
}

export function fetchDreamcastPlaylistTypes() {
  return request("/config/playlist-types");
}

export function createDreamcastPlaylistType(type) {
  return request("/config/playlist-types", {
    method: "POST",
    body: JSON.stringify({ label: type }),
  });
}

export function deleteDreamcastPlaylistType(type) {
  const encodedType = encodeURIComponent(type);
  return request(`/config/playlist-types/${encodedType}`, {
    method: "DELETE",
  });
}

export function moveDreamcastPlaylistTempImage(
  playlistId,
  tempFilename,
  oldUrl,
) {
  return request(`/playlists/${playlistId}/move-image`, {
    method: "POST",
    body: JSON.stringify({ tempFilename, oldUrl }),
  });
}
